import React from "react";
import { Scissors, RotateCcw } from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { FrameInput } from "@/components/cleanplate/PartsPanel";

// In-memory trim: only the chosen frame range is processed; the original file is never re-exported.
export default function VirtualTrim({ total, fps, value, onChange, testid = "cp-vtrim", note = "outside frames stay original in the final video" }) {
  const last = Math.max(0, total - 1);
  const [a, b] = value || [0, last];
  const set = (x, y) => { const lo = Math.max(0, Math.min(x, y)), hi = Math.min(last, Math.max(x, y)); onChange(lo === 0 && hi === last ? null : [lo, hi]); };
  return (
    <div className="rounded-lg border border-zinc-800 p-2.5 space-y-2" data-testid={testid}>
      <div className="text-xs text-zinc-300 flex items-center gap-1.5"><Scissors className="w-3.5 h-3.5 text-[#41a7f5]" />Trim (virtual — original file untouched)
        {value && <button type="button" onClick={() => onChange(null)} data-testid={`${testid}-reset`} className="ml-auto text-[10px] text-zinc-400 hover:text-white flex items-center gap-1"><RotateCcw className="w-3 h-3" />Full clip</button>}
      </div>
      <Slider min={0} max={last} step={1} value={[a, b]} onValueChange={([x, y]) => set(x, y)} data-testid={`${testid}-slider`} />
      <div className="grid grid-cols-2 gap-2">
        <label className="text-[10px] text-zinc-400">Start frame<FrameInput value={a} max={last} onCommit={(n) => set(n, b)} testid={`${testid}-start`} className="ax-input bfx-input !h-8 text-xs mt-1 w-full font-mono" /></label>
        <label className="text-[10px] text-zinc-400">End frame<FrameInput value={b} max={last} onCommit={(n) => set(a, n)} testid={`${testid}-end`} className="ax-input bfx-input !h-8 text-xs mt-1 w-full font-mono" /></label>
      </div>
      <div className="text-[10px] font-mono text-zinc-500" data-testid={`${testid}-info`}>{b - a + 1} frames · {((b - a + 1) / (fps || 24)).toFixed(2)} s · becomes frames 0–{b - a}; {note}</div>
    </div>
  );
}
